import { useEffect, useState } from "react";
import { Phone, EnvelopeSimple, MapPin, WhatsappLogo } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import api from "@/lib/api";

export default function Contact() {
  const [s, setS] = useState({});
  useEffect(() => {
    api.get("/public/settings").then(({ data }) => setS(data)).catch(() => {});
  }, []);

  const wa = s.whatsapp_number ? `https://wa.me/${s.whatsapp_number}` : "#";

  return (
    <div className="mx-auto max-w-4xl px-4 sm:px-6 py-16">
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-slate-900">Contact Us</h1>
      <p className="mt-3 text-lg text-slate-600">
        Speak with our team — by phone, email or WhatsApp. Most customers place orders in minutes.
      </p>

      <div className="mt-10 grid sm:grid-cols-2 gap-5">
        <div className="border border-[#E5E7EB] rounded-lg p-6 bg-white">
          <Phone size={26} className="text-[#0A4F35]" />
          <h3 className="mt-3 font-display font-semibold text-slate-900">Phone</h3>
          <p className="text-slate-600" data-testid="contact-phone">{s.phone || "—"}</p>
        </div>
        <div className="border border-[#E5E7EB] rounded-lg p-6 bg-white">
          <EnvelopeSimple size={26} className="text-[#0A4F35]" />
          <h3 className="mt-3 font-display font-semibold text-slate-900">Email</h3>
          <p className="text-slate-600" data-testid="contact-email">{s.email || "—"}</p>
        </div>
        <div className="border border-[#E5E7EB] rounded-lg p-6 bg-white">
          <MapPin size={26} className="text-[#0A4F35]" />
          <h3 className="mt-3 font-display font-semibold text-slate-900">Address</h3>
          <p className="text-slate-600">{s.address || "—"}</p>
        </div>
        <div className="border border-[#E5E7EB] rounded-lg p-6 bg-white flex flex-col">
          <WhatsappLogo size={26} weight="fill" className="text-[#16A34A]" />
          <h3 className="mt-3 font-display font-semibold text-slate-900">WhatsApp</h3>
          <a href={wa} target="_blank" rel="noreferrer" className="mt-auto">
            <Button className="mt-3 w-full bg-[#16A34A] hover:bg-[#128a3d] text-white">Chat on WhatsApp</Button>
          </a>
        </div>
      </div>

      <div className="mt-10 rounded-lg bg-[#F9FAFB] border border-[#E5E7EB] p-6 flex items-center justify-between flex-wrap gap-4">
        <p className="text-slate-700 font-medium">Prefer to order online?</p>
        <Link to="/request-fuel"><Button className="bg-[#E5B800] hover:bg-[#CCA300] text-black font-semibold">Request Fuel</Button></Link>
      </div>
    </div>
  );
}
